export default function Testimonials() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            お客様の声
          </h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">匿名・実際の利用ケース</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-gradient-to-br from-blue-50 to-white p-8 rounded-2xl border border-blue-100 hover:shadow-xl transition-shadow">
            <div className="w-14 h-14 flex items-center justify-center bg-blue-100 text-blue-600 rounded-xl mb-6">
              <i className="ri-building-line text-2xl"></i>
            </div>
            
            <div className="mb-4">
              <div className="flex gap-1 mb-3">
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
              </div>
              
              <p className="text-gray-700 leading-relaxed mb-4">
                「学会提出資料の締切が迫っていたのですが、必要な論文を当日中に入手できて本当に助かりました。」
              </p>
            </div>
            
            <div className="flex items-center gap-2 text-sm font-medium text-gray-600">
              <div className="w-8 h-8 flex items-center justify-center bg-gray-200 rounded-full">
                <i className="ri-building-line text-sm text-gray-600"></i>
              </div>
              製薬企業 MR（40代）
            </div>
          </div>
          
          <div className="bg-gradient-to-br from-blue-50 to-white p-8 rounded-2xl border border-blue-100 hover:shadow-xl transition-shadow">
            <div className="w-14 h-14 flex items-center justify-center bg-green-100 text-green-600 rounded-xl mb-6">
              <i className="ri-briefcase-line text-2xl"></i>
            </div>
            
            <div className="mb-4">
              <div className="flex gap-1 mb-3">
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
              </div>
              
              <p className="text-gray-700 leading-relaxed mb-4">
                「自分で出版社サイトを検索する時間が省けてコスパが良い！」
              </p>
            </div>
            
            <div className="flex items-center gap-2 text-sm font-medium text-gray-600">
              <div className="w-8 h-8 flex items-center justify-center bg-gray-200 rounded-full">
                <i className="ri-briefcase-line text-sm text-gray-600"></i>
              </div>
              製薬広告代理店（30代）
            </div>
          </div>
          
          <div className="bg-gradient-to-br from-blue-50 to-white p-8 rounded-2xl border border-blue-100 hover:shadow-xl transition-shadow">
            <div className="w-14 h-14 flex items-center justify-center bg-purple-100 text-purple-600 rounded-xl mb-6">
              <i className="ri-user-line text-2xl"></i>
            </div>
            
            <div className="mb-4">
              <div className="flex gap-1 mb-3">
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
              </div>
              
              <p className="text-gray-700 leading-relaxed mb-4">
                「面倒なアカウント登録も必要なく、支払いも【円】で出来るので、社内の経費処理も楽で助かります。」
              </p>
            </div>
            
            <div className="flex items-center gap-2 text-sm font-medium text-gray-600">
              <div className="w-8 h-8 flex items-center justify-center bg-gray-200 rounded-full">
                <i className="ri-user-line text-sm text-gray-600"></i>
              </div>
              製薬企業　学術（50代）
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
